import { TZDate, tz } from '@date-fns/tz';
import { parseISO, set } from 'date-fns';

const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

let tenantZone: string | undefined;

export const setTenantTimeZone = (zone?: string) => {
  tenantZone = zone || undefined;
};

export const getTenantTimeZone = () => tenantZone;

export const inTenantZone = () => tz(tenantZone || browserZone);

export const toTenantDate = (value: Date | string | number) =>
  new TZDate(typeof value === 'string' ? parseISO(value).getTime() : +value, tenantZone);

export const tenantNow = () => toTenantDate(Date.now());

export const setTenantTime = (time: Date, day: Date = tenantNow()) =>
  set(toTenantDate(day), {
    hours: time.getHours(),
    minutes: time.getMinutes(),
    seconds: 0,
    milliseconds: 0,
  });

export const fromCalendarDay = (day: Date) =>
  new TZDate(day.getFullYear(), day.getMonth(), day.getDate(), tenantZone);

export const toTenantWallClock = (date: Date) =>
  new TZDate(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds(),
    tenantZone,
  );

export const parseTenantDateTime = (value: string) =>
  value.includes('T') ? toTenantDate(value) : fromCalendarDay(parseISO(value));

export const toLocalWallClock = (date: Date) =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds(),
  );

export const toCalendarDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const tenantToday = () => toCalendarDay(tenantNow());

export const isBrowserInTenantZone = () => !tenantZone || tenantZone === browserZone;

export const getTimeZoneOf = (date: Date) => (date instanceof TZDate ? date.timeZone : undefined);

export const getTenantTimeZoneName = (locale?: string) => {
  if (!tenantZone) return '';
  const part = new Intl.DateTimeFormat(locale, {
    timeZone: tenantZone,
    timeZoneName: 'longGeneric',
  })
    .formatToParts(new Date())
    .find((el) => el.type === 'timeZoneName');
  return part?.value || tenantZone;
};
